export default {
    labels: {
        title: 'Análisis del documento: ',
        subtitle: 'Se encontraron discrepancias. Consulte los campos a revisar a continuación.',
        valueNotFound: 'No encontrado',
        confidencePercentage: 'Confianza',
        denialRisk: 'Riesgo de rechazo: ',
        howToFix: 'Cómo corregir: '
    },
    grid: {
        columns: {
            field: 'Campo',
            valueReadedByAi: 'Lo que se leyó en el documento',
            reason: 'Motivos de rechazo',
            status: 'Estado'
        }
    },
    actions: {
        replaceDocument: 'Reemplazar documento',
        cancel: 'Cancelar'
    },
    errorReasons: {
        requiredFieldNotProvided: {
            reason: 'Este campo en el documento es obligatorio y no ha sido completado',
            howToFix: 'Complételo siguiendo los estándares requeridos para este tipo de documento'
        },
        incorrectValue: {
            reason: 'Este campo no cumple con los estándares de la ANS.',
            howToFix: 'Complételo siguiendo los estándares requeridos para este tipo de documento.'
        },
        conflictValues: [
            {
                subreasonKey: 'Value Differs from Osigu Input',
                reason: 'Este campo en el documento difiere de la información registrada en el sistema',
                howToFix: 'Verifique el campo {field} en su sistema'
            },
            {
                subreasonKey: 'Inconsistency detected in doctor´s name',
                reason: 'Este campo fue completado como {value}, pero este nombre no corresponde al profesional asociado con el CRM proporcionado.',
                howToFix: 'Corrija este campo y actualícelo con el nombre completo según el registro en el consejo.'
            },
            {
                subreasonKey: 'Doctor has an inactive CRM status',
                reason: 'Este campo fue completado con el número {value}, pero este CRM está inactivo en el consejo profesional.',
                howToFix: 'Reemplácelo por el registro de un profesional activo y también actualice el nombre correspondiente en el campo 15.'
            },
            {
                subreasonKey: 'Invalid Procedure Code',
                reason: 'Este campo fue completado con el código {value}, pero está inactivo en la tabla TUSS vigente',
                howToFix: 'Consulte la versión más reciente de la tabla TUSS proporcionada por la ANS y sustitúyalo por un código activo que corresponda al procedimiento solicitado.'
            },
            {
                subreasonKey: 'Procedure code does not match procedure',
                reason: 'Este campo fue completado con el código {value}, pero no corresponde con la descripción del procedimiento indicada en el documento.',
                howToFix: 'Sustitúyalo por el código TUSS que corresponda a la descripción correcta.'
            }
        ],
        documentNotMatched: {
            reason: 'El archivo enviado no parece ser una Guía TISS válida.',
            howToFix: 'Verifique si el documento adjunto corresponde a una Guía TISS'
        }
    }
}